import axios from 'axios'
import {ResponseObject, ResponseObjectPaginated} from '../model'
import {
  AttendClaimDocument,
  AttendClaimModel,
  ClaimDocument,
  ClaimModel,
  ClaimModelDocument,
  GetClaimFilter,
  GetClaimModel,
} from '../model/claim.model'
import {ID} from '../../../../../_metronic/helpers'

const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getClaims(dto: GetClaimFilter) {
  return axios.post<ResponseObjectPaginated<ClaimModelDocument[]>>(
    `${BASEURL}/request/getList`,
    dto,
  )
}

export async function createClaim(dto: ClaimModel) {
  return await axios.post<ResponseObject<ClaimModel>>(`${BASEURL}/request/createRequest`, dto)
}

export async function getClaimById(id: string | undefined | number) {
  return await axios.get<ResponseObject<GetClaimModel>>(`${BASEURL}/request/getRequestById`, {
    params: {
      Id: id,
    },
  })
}

export async function updateClaim(dto: ClaimModel) {
  return await axios.put<ResponseObject<ClaimModel>>(`${BASEURL}/request/updateRequest`, dto)
}

export async function getAttentionList(requerimientoId: string) {
  return await axios.get<ResponseObjectPaginated<AttendClaimDocument>>(
    `${BASEURL}/request/getListAttention?RequerimientoId=${requerimientoId}`,
  )
}

export async function deleteClaim(requerimientoId: string | undefined) {
  return await axios.delete<ResponseObject<ClaimModel>>(
    `${BASEURL}/request/deleteRequest?requerimientoId=${requerimientoId}`,
  )
}

// NOTES

export function getClaimDocumentsService(requerimientoId: ID) {
  return axios.get<ResponseObjectPaginated<ClaimDocument[]>>(
    `${BASEURL}/request/getListDocument?RequerimientoId=${requerimientoId}`,
  )
}

export async function createClaimDocumentsService(test: any, requerimientoId: ID) {
  return await axios.post<ResponseObject<ClaimDocument>>(
    `${BASEURL}/request/createRequestDocument?RequerimientoId=${requerimientoId}`,
    test,
  )
}

export async function createClaimAttentionService(dto: any) {
  return await axios.post<ResponseObject<AttendClaimModel>>(
    `${BASEURL}/request/createRequestAttention`,
    dto,
  )
}

export async function updateClaimAttentionService(dto: any) {
  return await axios.post<ResponseObject<AttendClaimModel>>(
    `${BASEURL}/request/updateRequestAttention`,
    dto,
  )
}

export async function finalizeClaim(requerimientoId: ID) {
  return axios.put<ResponseObject<ClaimModel>>(
    `${BASEURL}/request/finalizeRequest?requerimientoId=${requerimientoId}`,
  )
}

export function downloadClaimDocumentsService(requerimientoId: any) {
  return axios.get<any>(
    `${BASEURL}/request/downloadRequestDocument?RequerimientoId=${requerimientoId}`,
  )
}

export function downloadClaimDocumentsServiceV(requerimientoId: any) {
  return axios.get<any>(
    `${BASEURL}/request/downloadRequestDocument_file?RequerimientoId=${requerimientoId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function downloadClaimDocumentsAttentionService(requerimientoId: any) {
  return axios.get<any>(
    `${BASEURL}/request/downloadRequestAttentionDocument?RequerimientoAtencionId=${requerimientoId}`,
  )
}

export function downloadClaimDocumentsAttentionServiceV(requerimientoId: any) {
  return axios.get<any>(
    `${BASEURL}/request/downloadRequestAttentionDocument_file?RequerimientoAtencionId=${requerimientoId}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
      responseType: 'arraybuffer',
    },
  )
}
